<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title>
          <v-btn
            class="ma-2"
            color="secondary"
            @click="$router.back()"
            outlined
            dark
          >
            <v-icon>mdi-arrow-left</v-icon>
            Back
          </v-btn>
        </v-card-title>
        <v-card-title class="pl-6">Student</v-card-title>
        <div class="pa-5">
          <v-form ref="form">
            <v-select
              label="Customer"
              prepend-icon="mdi-face-man"
              item-text="description"
              item-value="id"
              :items="getCustomers"
              v-model="student.customer_id"
              disabled
              readonly
              outlined
            ></v-select>
            <v-select
              label="Select Courses"
              prepend-icon="mdi-format-list-bulleted-square"
              item-text="label"
              item-value="value"
              :items="courseSelections"
              v-model="student.courses"
              multiple
              outlined
              chips
            ></v-select>
            <v-text-field
              label="First Name"
              prepend-icon="mdi-text"
              :rules="[requiredRule]"
              v-model="student.first_name"
              outlined
            ></v-text-field>
            <v-text-field
              label="Last Name"
              prepend-icon="mdi-text"
              :rules="[requiredRule]"
              v-model="student.last_name"
              outlined
            ></v-text-field>
            <v-text-field
              label="Email"
              prepend-icon="mdi-at"
              :rules="[requiredRule, emailRule]"
              v-model="student.email"
              outlined
            ></v-text-field>
            <v-col class="d-flex align-center pa-0">
              <v-text-field
                label="Username"
                prepend-icon="mdi-text"
                :loading="usernameLoading"
                :error-messages="usernameError"
                :rules="[requiredRule]"
                v-model="student.username"
                outlined
              ></v-text-field>
              <v-btn
                color="primary"
                class="ml-4 mb-8"
                @click="generateUserName"
              >
                Generate Username
              </v-btn>
            </v-col>
            <div class="d-flex align-center">
              <v-text-field
                label="Password"
                prepend-icon="mdi-form-textbox-password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                :rules="[requiredRule]"
                v-model="student.password"
                outlined
              ></v-text-field>
              <v-btn
                color="primary"
                class="ml-4 mb-8"
                @click="generatePassword"
              >
                Generate Password
              </v-btn>
            </div>
            <v-text-field
              label="Function Name"
              prepend-icon="mdi-text"
              :rules="[requiredRule]"
              v-model="student.function"
              outlined
            ></v-text-field>
            <v-text-field
              label="Number"
              prepend-icon="mdi-text"
              v-model="student.number"
              outlined
            ></v-text-field>
            <v-col class="py-0">
              <v-switch
                class="mt-2"
                label="Disabled"
                v-model="student.disabled"
                :true-value="1"
                :false-value="0"
                inset
              ></v-switch>
            </v-col>
            <v-row justify="end">
              <v-btn
                color="primary"
                @click="save"
                :disabled="loading || getCustomersLoading"
                :loading="loading"
              >
                Add Student
              </v-btn>
            </v-row>
          </v-form>
        </div>
      </base-card>
      <template>
        <v-row justify="center">
          <v-dialog max-width="1000px" v-model="actionDialog" persistent>
            <v-card>
              <v-card-title>Added New Student</v-card-title>
              <v-card-text class="py-0">
                <template>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Username</th>
                          <th>Password</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Student Number</th>
                          <th>Customer</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="student-row">
                          <td>{{ student.username }}</td>
                          <td>{{ student.password }}</td>
                          <td>
                            {{ student.first_name }} {{ student.last_name }}
                          </td>
                          <td>{{ student.email }}</td>
                          <td>{{ student.number }}</td>
                          <td>{{ customer.description }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <v-radio-group
                    class="pt-3"
                    v-model="action"
                    column
                    hide-details
                  >
                    <template v-slot:label>
                      <div class="mb-2">
                        Choose action for sending login details.
                      </div>
                    </template>
                    <v-radio value="mail">
                      <template v-slot:label>
                        Mail login details to student
                      </template>
                    </v-radio>
                    <v-radio value="manual">
                      <template v-slot:label>
                        Send login details manually
                      </template>
                    </v-radio>
                  </v-radio-group>
                </template>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :disabled="loading"
                  :loading="loading"
                  @click="setAction"
                  text
                >
                  Confirm
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import { checkUsername } from "@/services/studentService";
import { CUSTOMER_ACTION } from "@/shared/constants";
import passwordGenerator from "generate-password";
import { debounce, filter, find, get, isEmpty, map } from "lodash";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo: {
    title: "Add Customer Student",
  },

  data() {
    return {
      id: get(this.$route, "params.id"),
      studentId: null,
      loading: false,
      actionDialog: false,
      showPassword: false,
      usernameError: [],
      usernameLoading: false,
      action: null,
      counter: 0,
      student: {
        customer_student: true,
        customer_id: null,
        first_name: null,
        last_name: null,
        email: null,
        username: null,
        password: null,
        function: null,
        number: null,
        disabled: 0,
        courses: [],
      },
      requiredRule: (v) => !!v || "This is required.",
      emailRule: (v) =>
        !!v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid",
    };
  },

  mounted() {
    this.student.customer_id = Number(this.id);
    this.student.courses = map(this.customerCourses, "id");
  },

  methods: {
    ...mapActions([
      "createStudent",
      "sendStudentLoginDetails",
      "exportStudentLoginDetails",
    ]),

    async validateUsername() {
      this.usernameLoading = true;

      const { data } = await checkUsername({
        id: this.id,
        username: _.get(this.student, "username"),
      });

      this.usernameError = data ? ["Username already exists."] : [];
      this.usernameLoading = false;
    },

    async generateUserName(exists = false) {
      let username = "";

      if (_.get(this.student, "last_name")) {
        username = this.student.last_name
          .replace(/[^A-Za-z0-9]/g, "")
          .replace(/ /g, "");
      }

      if (_.get(this.student, "name")) {
        username = this.student.name
          .replace(/[^A-Za-z0-9]/g, "")
          .replace(/ /g, "");
      }

      if (!username) {
        this.student.username = "";

        return;
      }

      if (exists === true) {
        this.counter++;
        username += this.counter;
      }

      if (username.length < 5) {
        const chars =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const charsLength = chars.length;

        while (username.length < 5) {
          username += chars.charAt(Math.floor(Math.random() * charsLength));
        }
      }

      const { data } = await checkUsername({
        id: this.id,
        username,
      });

      if (data) {
        await this.generateUserName(true);

        return;
      }

      this.counter = 0;
      this.student.username = username;
    },

    generatePassword() {
      this.student.password = passwordGenerator.generate({
        length: 10,
        numbers: true,
        lowercase: true,
        uppercase: true,
        excludeSimilarCharacters: true,
      });
    },

    async save() {
      this.loading = true;

      if (!this.$refs.form.validate()) {
        this.$store.dispatch("showSnackbar", "One or more fields are invalid.");
        this.loading = false;

        return;
      }

      try {
        const response = await this.createStudent(this.student);

        if (!isEmpty(response)) {
          this.studentId = get(response, "id");
          this.actionDialog = true;
        }

        this.$store.dispatch("showSnackbar", "Student created.");
      } catch (error) {
        console.error("DEBUG: error", error);
      }

      this.loading = false;
    },

    async setAction() {
      this.loading = true;

      if (!this.action) {
        this.$store.dispatch("showSnackbar", "Please select an option.");
        this.loading = false;

        return;
      }

      switch (this.action) {
        case CUSTOMER_ACTION.MAIL:
          const emailResponse = await this.sendStudentLoginDetails({
            id: this.studentId,
            password: this.student.password,
          });

          if (!isEmpty(emailResponse)) {
            this.$store.dispatch("showSnackbar", "Email sent.");
          }

          break;
        case CUSTOMER_ACTION.MANUAL:
          const response = await this.exportStudentLoginDetails({
            id: this.studentId,
            password: this.student.password,
          });

          if (!isEmpty(response)) {
            const fileName = `${moment().format("YYYY-MM-DD")}-student.csv`;

            const url = window.URL.createObjectURL(new Blob([response]));
            let link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", fileName);

            document.body.appendChild(link);
            link.click();
          }

          break;
      }

      this.loading = false;
      this.actionDialog = false;
      this.$router.back();
    },
  },
  computed: {
    ...mapGetters([
      "getCustomers",
      "getStudents",
      "getCustomersLoading",
      "getCustomerStudents",
      "getCustomerCourses",
    ]),

    customer() {
      return find(this.getCustomers, { id: +this.id });
    },

    customerCourses() {
      return filter(get(this.getCustomerCourses[+this.id], "courses"));
    },

    courseSelections() {
      const selections = [];

      if (!isEmpty(this.customerCourses)) {
        this.customerCourses.forEach((item) => {
          const label = get(item, "scorm_id")
            ? get(item, "scorm.scorm_sco.title")
            : get(item, "course.description");

          selections.push({
            label,
            value: item.id,
          });
        });
      }

      return selections;
    },
  },
  watch: {
    "student.username": debounce(function () {
      this.validateUsername();
    }, 500),
    immediate: true,
    deep: true,
  },
};
</script>
<style lang="scss" scoped>
.student-row {
  background-color: #eeeeee;
}
</style>
